import { FRUITS } from './Fruits.data';

export function constructSnippet(numOfFruits = 1) {
  const additionalFruits = FRUITS.slice(1, numOfFruits);

  let codeSnippet = `// Point the \`fruits\` label at this array:
const fruits = ['apple'];`;

  if (additionalFruits.length > 0) {
    codeSnippet = `${codeSnippet}

// Modify the array:
fruits.push('${additionalFruits.join("', '")}');`;
  } else {
    codeSnippet = `${codeSnippet}

// ⚠️ Click the “Add Item” button to mutate the array!`;
  }

  return codeSnippet;
}
